import { net_filemanage } from "@/api/http";
export const API_STFMFM02C01 = (...params) =>
net_filemanage.post("/api/STFMFM02C01/Initialize", ...params)
export const API_STFMFM02C01_SetBop = (...params) =>
net_filemanage.post("/api/STFMFM02C01/SetBop", ...params)
export const API_STFMFM02C01_SetFilter = (...params) =>
net_filemanage.post("/api/STFMFM02C01/SetFilter", ...params)
export const API_STFMFM02C01_GetMailAddress = (...params) =>
net_filemanage.post("/api/STFMFM02C01/GetMailAddress", ...params)
